import type React from "react";
import {memo} from "react";

import PopoverInfo from "../PopoverInfo";
import {FormControlLabel, FormControlLabelText} from "../ui/formcontrol";

export type Props = {
    label?: string;
    size?: "xs" | "sm";
    tooltip?: React.ReactNode;
} & StrictUnion<
    | {
          label?: string;
      }
    | {
          children?: React.ReactNode;
      }
>;

const Label: React.FC<Props> = ({label, tooltip, size = "sm", children}) => {
    return (
        <FormControlLabel className="gap-0.5">
            {(label || typeof children === "string") && (
                <FormControlLabelText isTruncated color="blueGray.400" variant={size}>
                    {label || children}
                </FormControlLabelText>
            )}
            {children && typeof children !== "string" && children}
            {tooltip && <PopoverInfo label={tooltip} />}
        </FormControlLabel>
    );
};

export default memo(Label);
